import { render, staticRenderFns } from "./GeneralSettingsCloudinary.vue?vue&type=template&id=43efd853&"
import script from "./GeneralSettingsCloudinary.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCloudinary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports